import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

import CardButtons from './CardButtons';
import ContactDialog from './ContactDialog';
import PaymentMethodDialog from './PaymentMethodDialog';

import { uiUserOrdersTab } from '../../../../actions/ui';
import { getTitle } from '../../../../helpers/admin/productHelper';
// import { showAgainOrderInList } from '../../../../actions/user-account';

import {
    Box, Button, Card, CardContent, Container, Divider, Grid,
    Typography, Alert, List, ListItem, LinearProgress, // IconButton, Snackbar,
    Stack, ListItemIcon, ListItemText, useMediaQuery
} from '@mui/material';
import LoopIcon from '@mui/icons-material/Loop';
import RefreshIcon from '@mui/icons-material/Refresh';
// import CloseIcon from '@mui/icons-material/Close';
import LabelImportantIcon from '@mui/icons-material/LabelImportant';
import LoadingButton from '@mui/lab/LoadingButton';

import { DATE_OPTIONS } from '../../../../constants/date_const';
import { LAST_ORDER } from '../../../../constants/shop/order_const';
import { GOOGLE_DRIVE_CDN, PRODUCT_NO_IMG } from '../../../../constants/constants';

const InactiveOrderList = ({ loading, inactive_skip, getMoreOrders }) => {
    const { _screen, _button } = loading;
    const matches = useMediaQuery('(max-width:425.9px)');
    const matches_img = useMediaQuery('(max-width: 530px)');

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {
        inactive_orders, order_count: { inactive }
    } = useSelector(state => state.user_account);

    const [orderCounter, setOrderCounter] = useState(-1);
    const [lastOrder, setLastOrder] = useState(LAST_ORDER); // pedido seleccionado
    const { order_num, summary: { total }, payment } = lastOrder;
    const [hiddenOrder, setHiddenOrder] = useState(LAST_ORDER); // último pedido ocultado

    const [data, setData] = useState({
        dialog1: false, dialog2: false, snackbar1: false
    });
    const { dialog1, dialog2, snackbar1 } = data;

    useEffect(() => {
        if (orderCounter === -1) // cantidad de pedidos
            setOrderCounter(inactive_orders.length);
        else {
            // se ocultó un pedido
            if (inactive_orders.length < orderCounter)
                setData(e => ({ ...e, snackbar1: true })); // abrir snackbar
            // actualizar cantidad de pedidos actual
            setOrderCounter(inactive_orders.length);
        }
    }, [inactive_orders]);

    // const orderTracking = order_num => () => {
    //     const filter = inactive_orders.find(e => e.order_num === order_num);
    //     if (filter)
    //         navigate(`/rastrear-pedido/${filter.payment.nefro_reference}`, { state: filter });
    // };

    const goToProduct = url => () => {
        navigate(`/tienda/producto/${url}`);
    };

    // volver a mostrar (undo)
    // const showOrderAgain = async () => {
    //     if (hiddenOrder.order_num)
    //         dispatch(showAgainOrderInList(hiddenOrder, setData));
    // };

    // const handleClose = (event, reason) => {
    //     if (reason === 'clickaway') return;
    //     setData(e => ({ ...e, snackbar1: false }));
    // };

    // se selecciona pedido para cambiar método de pago
    const selectOrder = order_num => () => {
        const OrderFound = inactive_orders.find(e => e.order_num === order_num);
        if (OrderFound) {
            setLastOrder(e => ({ ...e, ...OrderFound }));
            setData(e => ({ ...e, dialog1: true }));
        }
    };

    // const action = (
    //     <React.Fragment>
    //         <Button color="secondary" size="small"
    //             onClick={ showOrderAgain }>
    //             DESHACER
    //         </Button>
    //         <IconButton
    //             size="small"
    //             aria-label="close"
    //             color="inherit"
    //             onClick={ handleClose }
    //         >
    //             <CloseIcon fontSize="small" />
    //         </IconButton>
    //     </React.Fragment>
    // );

    return (
        _screen ? (
            <Stack spacing={2}>
                <Alert severity="info">
                    Cargando sus pedidos...
                </Alert>
                <LinearProgress color="info" />
            </Stack>
        ) : (
            <Box sx={{ mb: 4 }}>
                <Alert severity="info" sx={{ mb: 2 }}>
                    <Typography variant="body1" gutterBottom>
                        En esta sección puedes encontrar aquellos pedidos que realizaste pero se encuentran inactivos, posiblemente por las siguientes situaciones:
                    </Typography>
                    <List>
                        <ListItem disablePadding>
                            <ListItemIcon>
                                <LabelImportantIcon />
                            </ListItemIcon>
                            <ListItemText primary="Ya realizaste el pago pero no se ha reflejado" />
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemIcon>
                                <LabelImportantIcon />
                            </ListItemIcon>
                            <ListItemText primary="Tu banco no ha aprobado tu pago por diversas razones" />
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemIcon>
                                <LabelImportantIcon />
                            </ListItemIcon>
                            <ListItemText primary="Abandonaste el proceso de compra en el último paso" />
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemIcon>
                                <LabelImportantIcon />
                            </ListItemIcon>
                            <ListItemText primary="Cancelaste el pedido" />
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemIcon>
                                <LabelImportantIcon />
                            </ListItemIcon>
                            <ListItemText primary="Se realizó el reembolso del pedido" />
                        </ListItem>
                    </List>
                    <Typography variant="body1" gutterBottom>
                        SI ESTÁS SEGURO DE HABER REALIZADO EL PAGO Y NO APARECE EN TU LISTA COMO APROBADO, DEBES ESPERAR UN TIEMPO A QUE SE VEA REFLEJADO.
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        CUALQUIER DUDA O ACLARACIÓN ESCRIBIRNOS AL CORREO MEDIANTE EL <HashLink to="#contact-form">FORMULARIO</HashLink> QUE SE ENCUENTRA AL FINAL DE ESTA PÁGINA.
                    </Typography>
                </Alert>

                {
                    inactive_orders.length > 0 ?
                        <Box>
                            {
                                inactive_orders.map(
                                    ({
                                        _id, order_num, products, shipping,
                                        payment: { available }, order_date
                                    }) => {
                                    const len = products.length;
                                    const today = new Date(order_date);
                                    const status = shipping.esp_status;
                                    return (
                                        
                                            <Card key={_id || order_num} sx={{
                                                width: '100%', boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)', mb: 4
                                            }}>
                                                <CardContent>
                                                    <Box sx={{
                                                        flexWrap: 'wrap', justifyContent: 'space-between',
                                                        display: { xs: 'none', sm: 'none', md: 'flex', lg: 'flex' }
                                                    }}>
                                                        <Box sx={{ mb: { xs: 0, sm: 0, md: 1.5, lg: 0, xl: 0 } }}>
                                                            <Typography sx={{ fontSize: 14 }} color="text.secondary">
                                                                No. Pedido: <b>ONL-{order_num}</b>
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                                                            <Typography sx={{ fontSize: 14 }}>
                                                                {`Estatus del pedido: `}
                                                                <Link to="/rastrear-pedido"
                                                                    style={
                                                                        ['Enviado', 'Entregado'].includes(status) ?
                                                                            { color: '#229954', fontWeight: '700' }
                                                                            :
                                                                            ['En espera', 'Preparando'].includes(status) ?
                                                                                { color: '#F1C40F', fontWeight: '700' }
                                                                                :
                                                                                { color: '#C0392B', fontWeight: '700' }
                                                                    }>
                                                                    {status}
                                                                </Link>
                                                            </Typography>
                                                            <Divider orientation="vertical" sx={{ mx: 1.5 }} />
                                                            <Typography sx={{ fontSize: 14 }}>
                                                                Realizado el <b>{
                                                                    `${today.toLocaleDateString("es-MX", DATE_OPTIONS)}`
                                                                }</b>
                                                            </Typography>
                                                        </Box>
                                                    </Box>

                                                    {available &&
                                                        <Button variant="contained"
                                                            sx={{ mt: 1, textTransform: 'none' }}
                                                            onClick={selectOrder(order_num)}>
                                                            Continuar con el pago
                                                        </Button>
                                                    }

                                                    <Divider sx={{ my: 1.8, display: { xs: 'none', sm: 'none', md: 'block', lg: 'block' } }} />

                                                    <Grid container spacing={matches ? 1.5 : 2} sx={{ px: { xs: 0, sm: 0, md: 0, lg: 2 } }}>
                                                        {
                                                            len > 1 ?
                                                                <>
                                                                    {
                                                                        products.map((res, index) => (
                                                                            <React.Fragment key={index}>
                                                                                <Grid item xl={3} lg={3} md={4} sm={4} xs={4}
                                                                                    className="animate__animated animate__fadeInLeft">
                                                                                    <img width={
                                                                                            matches_img ? '100%' : '90%'
                                                                                        } alt={
                                                                                            res.images.length > 0 ?  res.images[0].alt : 'producto-nefropolis'
                                                                                        } src={
                                                                                            `${GOOGLE_DRIVE_CDN}${
                                                                                                res.images.length > 0 ? res.images[0].id : PRODUCT_NO_IMG
                                                                                            }`
                                                                                        } onClick={
                                                                                            goToProduct(products[0].url)
                                                                                        } style={{ cursor: 'pointer' }}
                                                                                    />
                                                                                </Grid>
                                                                                <Grid item xl={9} lg={9} md={8} sm={8} xs={8}
                                                                                    sx={{ my: { xs: 'auto', sm: 'auto', md: 'auto', lg: 'auto' } }}>
                                                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                                        <Box>
                                                                                            <Typography variant={matches ? 'body1' : 'h6'} sx={{ fontWeight: '600' }} gutterBottom>
                                                                                                {` ${ getTitle(res.title, res.variant_title) }` }
                                                                                            </Typography>
                                                                                            <Typography variant='body2'
                                                                                                sx={{ display: { xs: 'block', sm: 'block', md: 'none', lg: 'none' } }}>
                                                                                                Fecha de compra: <b>{
                                                                                                    `${today.toLocaleDateString("es-MX", DATE_OPTIONS)}`
                                                                                                }</b>
                                                                                            </Typography>
                                                                                            <Box sx={{ display: { xs: 'none', sm: 'none', md: 'block', lg: 'block' } }}>
                                                                                                <Typography variant='body2' color='text.secondary'
                                                                                                    sx={{ textTransform: 'uppercase' }} gutterBottom>
                                                                                                    Categorías: {
                                                                                                        res.prod_category.map(({ category }, i) => {
                                                                                                            return i === res.prod_category.length - 1 ? category : `${category}, `
                                                                                                        })
                                                                                                    }
                                                                                                </Typography>
                                                                                                <Button
                                                                                                    variant='contained'
                                                                                                    onClick={() => {
                                                                                                        dispatch(uiUserOrdersTab('2'));
                                                                                                        window.scrollTo({ top: 0, left: 0 });
                                                                                                    }}
                                                                                                    size='small'
                                                                                                    sx={{ textTransform: 'none' }}
                                                                                                    endIcon={<LoopIcon />}>
                                                                                                    Comprar nuevamente
                                                                                                </Button>
                                                                                            </Box>
                                                                                        </Box>
                                                                                    </Box>
                                                                                </Grid>
                                                                            </React.Fragment>
                                                                        ))
                                                                    }
                                                                </>
                                                            :
                                                                <>
                                                                    <Grid item xl={3} lg={3} md={4} sm={4} xs={4}
                                                                        className="animate__animated animate__fadeInLeft">
                                                                        <img width={
                                                                                matches_img ? '100%' : '90%'
                                                                            } alt={
                                                                                products[0].images.length > 0 ?
                                                                                    products[0].images[0].alt
                                                                                :
                                                                                    'producto-nefropolis'
                                                                            } src={
                                                                                `${GOOGLE_DRIVE_CDN}${
                                                                                    products[0].images.length > 0 ?
                                                                                        products[0].images[0].id
                                                                                    :
                                                                                        PRODUCT_NO_IMG
                                                                                }`
                                                                            } onClick={
                                                                                goToProduct(products[0].url)
                                                                            } style={{ cursor: 'pointer' }}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xl={9} lg={9} md={8} sm={8} xs={8} sx={{ my: { xs: 'auto', sm: 'auto', md: 'auto', lg: 'auto' } }}>
                                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                            <Box>
                                                                                <Typography variant={matches ? 'body1' : 'h6'} sx={{ fontWeight: '600' }} gutterBottom>
                                                                                    {products[0].title}
                                                                                    {len > 1 && (<span>{` + ${len - 1} producto(s) `}</span>)}
                                                                                </Typography>
                                                                                <Typography variant='body2' sx={{ display: { xs: 'block', sm: 'block', md: 'none', lg: 'none' } }}>
                                                                                    Fecha de compra: <b>{
                                                                                        `${today.toLocaleDateString("es-MX", DATE_OPTIONS)}`
                                                                                    }</b>
                                                                                </Typography>
                                                                                <Box sx={{ display: { xs: 'none', sm: 'none', md: 'block', lg: 'block' } }}>
                                                                                    <Typography variant='body2' color='text.secondary'
                                                                                        sx={{ textTransform: 'uppercase' }}
                                                                                        gutterBottom>
                                                                                        Categorías: {
                                                                                            products[0].prod_category.map(({ category }, i) => {
                                                                                                return i === products[0].prod_category.length - 1 ? category : `${category}, `
                                                                                            })
                                                                                        }
                                                                                    </Typography>
                                                                                    <Button
                                                                                        variant='contained'
                                                                                        onClick={() => {
                                                                                            dispatch(uiUserOrdersTab('2'));
                                                                                            window.scrollTo({ top: 0, left: 0 });
                                                                                        }}
                                                                                        size='small'
                                                                                        sx={{ textTransform: 'none' }}
                                                                                        endIcon={<LoopIcon />}>
                                                                                        Comprar nuevamente
                                                                                    </Button>
                                                                                </Box>
                                                                            </Box>
                                                                        </Box>
                                                                    </Grid>
                                                                </>
                                                        }
                                                    </Grid>
                                                </CardContent>
                                                <Divider />
                                                <CardButtons
                                                    order_num={ order_num }
                                                    products={ products }
                                                    setHiddenOrder={ setHiddenOrder }
                                                />
                                            </Card>
                                    )
                                })
                            }
                            {
                                (inactive > inactive_skip) &&
                                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                        <LoadingButton
                                            size="large"
                                            endIcon={<RefreshIcon />}
                                            loading={ _button }
                                            loadingPosition="end"
                                            variant="contained"
                                            onClick={ getMoreOrders(false) }>
                                            Cargar mas pedidos
                                        </LoadingButton>
                                    </Box>
                            }
                        </Box>
                    :
                        <Container maxWidth="xl" sx={{ mt: 3 }}>
                            <Alert severity="info">No tiene pedidos pendientes</Alert>
                        </Container>
                    }
                {/* <Snackbar
                    open={ snackbar1 }
                    autoHideDuration={4000}
                    onClose={ handleClose }
                    message="Pedido oculto"
                    action={ action }
                /> */}
                <PaymentMethodDialog
                    open={ dialog1 }
                    setData={ setData }
                    orderData={ lastOrder }
                />
                <ContactDialog
                    open={ dialog2 }
                    setData={ setData }
                />
            </Box>
        )
    );
};

export default InactiveOrderList;
